// extracted by mini-css-extract-plugin
module.exports = {"date":"date__3HXGb","time-and-location":"time-and-location__3IOIP"};